import { render, staticRenderFns } from "./NewFacturePosition.vue?vue&type=template&id=244a8ec8&"
import script from "./NewFacturePosition.vue?vue&type=script&lang=js&"
export * from "./NewFacturePosition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports